const win: Window & typeof globalThis = globalThis.window ?? ({} as Window & typeof globalThis);

export { win as window };
